import { defineMessages } from 'react-intl';

export default defineMessages({
    farmQuote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.farm.Homeowners Insurance Quote',
        defaultMessage: 'Homeowners Insurance Quote'
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.farm.Location',
        defaultMessage: 'Location'
    }
});
